import { useUnit } from 'effector-react';
import { Info } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { assumptionsOpened } from '../../../entities/selection';
import { Button } from '../../../shared/ui';
import type { CanvasData } from './use-canvas';

/** Explains collapsed Monte Carlo bands: nothing in the plan is random yet. */
export function NoUncertaintyNote({ data }: { data: CanvasData }) {
  const { t } = useTranslation();
  const open = useUnit(assumptionsOpened);
  if (!data.mc || data.mc.hasUncertainty) return null;
  return (
    <div
      role="note"
      className="flex flex-wrap items-center gap-x-3 gap-y-1.5 rounded-md border border-border-subtle bg-bg-1 px-3 py-2 text-xs text-text-2"
    >
      <Info className="size-3.5 shrink-0 text-text-3" aria-hidden />
      <span className="min-w-0 flex-1">{t('mc.noUncertainty')}</span>
      <Button
        size="sm"
        onClick={() => {
          open();
        }}
      >
        {t('mc.openAssumptions')}
      </Button>
    </div>
  );
}
